skrilla.directive('updateUserStatus', function () {
    return {
        templateUrl: 'directives/updateUserStatus/updateUserStatus.html',
        scope: {
            user: "="
        },
        controller: function ($scope, modalService, cacheService) {
            $scope.pageKey = "updateUserStatus";
            cacheService.registerObject($scope.pageKey, $scope.user);

            $scope.search = function(){
                var callback = function(){
                    var id = cacheService.getObject($scope.pageKey);
                    if(id !== null && id !== undefined){
                        $scope.id = id;
                    }
                }
                modalService.openModal('/directives/updateUserStatus/updateUserStatusModal.html', true, 'lg', true, true, callback)
            };
        }
    };
});
